import Nullstack from 'nullstack';
export default function IconBuildingBroadcastTower({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building-broadcast-tower",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "1"
  }), "   ", Nullstack.element("path", {
    d: "M16.616 13.924a5 5 0 1 0 -9.23 .004"
  }), "   ", Nullstack.element("path", {
    d: "M20.307 15.469a9 9 0 1 0 -16.615 0"
  }), "   ", Nullstack.element("path", {
    d: "M9 21l3 -9l3 9"
  }), "   ", Nullstack.element("path", {
    d: "M10 19h4"
  }), " ");
}